import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Options } from 'ng5-slider';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContinuarProcesoComponent } from '../blocks/continuar-proceso/continuar-proceso.component';
import { ActivatedRoute } from '@angular/router';

declare var fbq;
declare var gtag;
declare var ga;

@Component({
  selector: 'app-cotizador-hogar',
  templateUrl: './cotizador-hogar.component.html',
  styleUrls: ['./cotizador-hogar.component.css']
})
export class CotizadorHogarComponent implements OnInit {

  data: any = {};
  errors: any = [];

  isLoading: boolean = false;
  cotizador: any = null;
  coberturas: any = null;
  provincias: any = null;
  ocupaciones: any = null;
  nacionalidades: any = null;
  planes: any = null;
  planSeleccionado: any = null;
  ccHorario: any = "";

  sa: number = 0;
  options: Options = {
    step: 5,
    translate: (value: number): string => {
      return '$' + value;
    }
  };

  mt2: number = 100;
  optionsMt2: Options = {
    step: 5,
    floor: 15,
    ceil: 200,
    translate: (value: number): string => {
      if (value == 200) {
        return '+ de 200 mt2';
      } else {
        return value + ' mt2';
      }
    }
  };


  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {

    this.data.step = 1;
    this.data.provincia = "";
    this.data.mismo_domicilio = "SI";

    this.api.getProvincias().subscribe(x => {
      this.provincias = x.data;
    });

    this.api.getOcupaciones().subscribe(x => {
      this.ocupaciones = x.data;
    });

    this.api.getNacionalidades().subscribe(x => {
      this.nacionalidades = x.data;
    });

    this.api.getCotizador("HO").subscribe(x => {
      this.cotizador = x.data;
    });

    let tmpCanal = document.location.href.split("?");

    if(tmpCanal[1]){
      this.data.canal = tmpCanal[1];
    }
    
  }

  ngOnInit() {

  }

  navigate(step: number) {
    if (this.data.step != 5) {
      if (this.data.step > step) {
        window.scrollTo(0, 0);
        this.errors = [];
        this.data.step = step;
      }
    }
  }

  captcha(e: any) {
    this.data.captcha = e;
  }

  selectPlan(evt: any) {
    window.scrollTo(0, 0);

    const modalRef = this.modalService.open(ContinuarProcesoComponent, { size: 'lg' });

    modalRef.result.then((data) => {
      if (data == 'BUY') {
        this.planSeleccionado = evt.plan;

        this.data.plan = evt.plan.productoNombre;
        this.data.cuota_mensual = evt.plan.cuota_mensual;

        this.updateLead(3);
      }
    });

  }

  cotizar() {
    window.scrollTo(0, 0);
    this.isLoading = true;
 
    this.data.mt2 = this.mt2;
    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;

        this.api.getProductosRecomendadosByMetros(this.cotizador.id, this.mt2, this.data.provincia).subscribe(x => {

          x.data.recomendado.cuota_mensual = Math.round((parseFloat(x.data.recomendado.cuota_mensual) + parseFloat(x.data.recomendado.sellado)) * 100) / 100;

          if (x.data.siguiente) {
            x.data.siguiente.cuota_mensual = Math.round((parseFloat(x.data.siguiente.cuota_mensual) + parseFloat(x.data.siguiente.sellado)) * 100) / 100;
          }

          if (x.data.anterior) {
            x.data.anterior.cuota_mensual = Math.round((parseFloat(x.data.anterior.cuota_mensual) + parseFloat(x.data.anterior.sellado)) * 100) / 100;
          }

          this.planes = x.data;
          this.data.step = 2;
          this.isLoading = false;

          fbq('track', 'Contact');

          gtag('event', 'dejarondatos', {
            'event_category': 'hogar',
            'event_label': 'dejarondatos'
          });
    
        });
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.isLoading = false;
      }

    }, err => {
      alert("Se ha producido un error");
    });


  }

  resumen() {
    this.updateLead(4);
  }

  finalizar() {
    this.updateLead(5);
  }

  updateLead(stepTo: number) {
    window.scrollTo(0, 0);
    this.isLoading = true;

    this.data.mt2 = this.mt2;
    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;

        if(stepTo == 5){
          this.api.getHorariosCC().subscribe(x=>{            
            this.ccHorario = x.data.mensaje;
            this.data.step = stepTo;
            this.isLoading = false;
          });
        }else{
          this.data.step = stepTo;
          this.isLoading = false;
  
        }

      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.isLoading = false;
      }

    }, err => {
      alert("Se ha producido un error");
    });

    if (stepTo == 3) {
      fbq('track', 'Lead');

      gtag('event', 'cotizacioncompleta', {
        'event_category': 'hogar',
        'event_label': 'cotizacioncompleta'
      });
    }

    if (stepTo == 5) {
      fbq('track', 'Purchase');

      gtag('event', 'resumensolicitud', {
        'event_category': 'hogar',
        'event_label': 'resumensolicitud'
      });

    }

  }

}
